module.exports = __webpack_public_path__ + "media/packs/site/assets/images/fr/fr_section04_img-5ede8d0e4621f63603dfaa56dad82203.png";